'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedSize',

  propTypes: {
    value: _react.PropTypes.number.isRequired
  },

  render: function render() {
    var _props = this.props,
        value = _props.value,
        options = _objectWithoutProperties(_props, ['value']);

    return _react2.default.createElement(
      'span',
      null,
      _I18n2.default.formatSize(value, options)
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.327/js/components/FormattedSize.js
// module id = 546
// module chunks = 2 3